"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const unitsPerTile_1 = __importDefault(require("./unitsPerTile"));
const cootsMaxVelocity = unitsPerTile_1.default * 16;
exports.default = cootsMaxVelocity;
